/**
 * INSTALLER-TEMPLATES-NOC-UX-1 — helpers PUROS para identificar/filtrar os
 * presets do Installer dentro da lista de config_templates do NOC.
 *
 * Os presets reservados (INSTALLER-TEMPLATES-MANAGE-1) são linhas em
 * config_templates com created_by = "system:installer-preset". A API já devolve
 * created_by em ConfigTemplateOut, então a identificação é client-side.
 */

export const INSTALLER_PRESET_CREATED_BY = "system:installer-preset";

/** True se o template é um preset reservado usado pelo InstallerPortal. */
export function isInstallerPreset(tpl) {
  return tpl?.created_by === INSTALLER_PRESET_CREATED_BY;
}

/** Filtra a lista por tipo: "all" | "installer" | "common". */
export function filterTemplatesByKind(templates, kind) {
  const list = templates || [];
  if (kind === "installer") return list.filter(isInstallerPreset);
  if (kind === "common") return list.filter((t) => !isInstallerPreset(t));
  return list;
}
